// src/utils/number.js
export const formatNumber = (num) => {
  if (num == null) return "";
  return new Intl.NumberFormat("en-US").format(num);
};
